import React, {Component} from 'react';
import logo from "../../assets/img/logo-white.png";
import {withRouter} from 'react-router-dom';

class About extends Component {
    constructor(props){
        super(props);

        this.state = {
            page: '',
            content: '',
            data: {},
            show: false
        }
    }

    renderLogo = () => {
        return (
            <span className="logo-about-modal"><b><img src={logo} /></b></span>
        )
    }

    submitReport = () => {

    }

    render(){
        return (
            <div
                className="modal fade"
                id="about"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="myModalLabel"
                
            >
                <div
                    // className="modal-dialog"
                    className={`modal-dialog about-modal animated flipInX`}
                    role="document"
                >
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="text-center" style={{zIndex: 2, position: 'relative'}}>
                                <div>
                                    {this.renderLogo()}
                                    <p>v0.9.6.21</p>
                                    <div className="collapse" id="report-collapse">
                                        <form onSubmit={e => {
                                            e.preventDefault();
                                            this.submitReport();
                                        }}>
                                            <label>Current Page</label>
                                            <input type="text" className="form-control" value={this.props.location.pathname} readOnly={true} placeholder="Current Page" /><br />

                                            <label>Outline the issue you're having</label>
                                            <textarea className="form-control" value={this.state.content} onChange={e => {
                                                this.setState({content: e.target.value});
                                            }} placeholder="Write your message.  Please include steps to replicate issue (ex. what were the last 5 things you did)." rows={6} style={{height: 300}} />
                                        </form>
                                    </div>
                                </div>
                                <br />
                                {this.state.show ?
                                    <div>
                                        <a className="btn btn-transparent btn-rounded" data-target="#report-collapse" data-toggle="collapse" onClick={e => this.setState({show: false})}><i className="zmdi zmdi-close" /> Cancel</a> &nbsp;
                                        <a className="btn btn-success btn-rounded" data-target="#report-collapse" data-toggle="collapse" onClick={e => this.setState({show: false})}><i className="zmdi zmdi-check" /> Submit</a>
                                    </div>
                                :
                                    <a className="btn btn-success btn-rounded" data-target="#report-collapse" data-toggle="collapse" onClick={e => this.setState({show: true, page: window.location.href})} ><i className="zmdi zmdi-alert-polygon" /> Report Bug</a>
                                }
                                <br />
                                
                            </div>
                        </div>
                        
                        


                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(About);


// WEBPACK FOOTER //
// ./src/components/Common/About.js